import {
  edgeRouteUrl,
  spaceEdgeHostnameSuffix,
  spaceEdgeOrigin,
  type TenantEdgeUrlOptions,
} from "../../shared/edgeUrl";
import { config } from "../environment";
import type { ParsedStep } from "./parseCommitData";

export function getStepCopyableUrl(
  step: ParsedStep,
  branchId: string,
  isOnMainBranch: boolean,
  spaceSlug: string,
  edgeUrlOptions: TenantEdgeUrlOptions,
  customDomain?: string | null,
  customHostname?: string | null
): string | null {
  if (!step.edgeRoute) return null;
  return getPageUrl(
    spaceSlug,
    step.edgeRoute,
    edgeUrlOptions,
    {
      branchId: isOnMainBranch ? null : branchId,
      externalId: step.routeExternalId,
    },
    customDomain,
    customHostname
  );
}

export function truncateMiddle(url: string, maxLength: number): string {
  const display = url.replace(/^https?:\/\//, "");
  if (display.length <= maxLength) return display;
  const keep = maxLength - 1;
  const start = Math.ceil(keep / 2);
  const end = Math.floor(keep / 2);
  return `${display.slice(0, start)}…${display.slice(-end)}`;
}

export function getStepCopyableEmailAddress(
  step: ParsedStep,
  branchId: string,
  isOnMainBranch: boolean,
  spaceSlug: string,
  edgeUrlOptions: TenantEdgeUrlOptions,
  customDomain?: string | null,
  customHostname?: string | null
): string | null {
  if (!step.emailAddress) return null;
  const { inboundEmailDomain, maxTenants } = config;
  const suffix = spaceEdgeHostnameSuffix(
    edgeUrlOptions,
    customDomain,
    spaceSlug
  );
  // A stack-wide email domain has no tenant identifier, so it requires a single-tenant stack.
  const host =
    customHostname ||
    (suffix
      ? `${spaceSlug}${suffix}`
      : maxTenants === 1
        ? inboundEmailDomain
        : null);
  if (!host) return null;
  const local = isOnMainBranch
    ? step.emailAddress
    : `${step.emailAddress}+${branchId}`;
  return `${local}@${host}`;
}

export function getPageUrl(
  spaceSlug: string,
  route: string,
  edgeUrlOptions: TenantEdgeUrlOptions,
  params?: { branchId?: string | null; externalId?: string | null },
  customDomain?: string | null,
  customHostname?: string | null
): string {
  if (customDomain) {
    edgeUrlOptions = {
      ...edgeUrlOptions,
      edgeUrl: `https://${customDomain}`,
      customDomain,
    };
  }
  return edgeRouteUrl(
    spaceEdgeOrigin(spaceSlug, edgeUrlOptions, customHostname),
    route,
    params
  );
}
